// const MAPBOX_TOKEN = "pk.eyJ1IjoiYXJrYXJ0aGljay14Ymk0IiwiYSI6ImNrdGIyMTFlaDBnamoyb215OGVoa3UyMDQifQ.BiEGZLhj7Z-lP3vuezmEcQ";  # Karthick's Account Token (Token disabled)
const MAPBOX_TOKEN = "pk.eyJ1IjoiaW5mb3RydXByb3BzIiwiYSI6ImNsZ2xveW9ocTA0dHAzZnAyaGFhYTI0a2oifQ.HIfTyAXZybbPqKPrYYKn3Q";  // # info@truprops Token

// const API_URL = "http://127.0.0.1:3003";
const API_DOMAIN = process.env.REACT_APP_DOMAIN_ENDPOINT;
const API_URL = process.env.REACT_APP_API_ENDPOINT;
const PROPERTY_API = process.env.REACT_APP_PROPERTY_API;

export { MAPBOX_TOKEN, API_URL, PROPERTY_API, API_DOMAIN };
